<div *ngIf="static; else videContainer" class="w-100; h-100">
  <app-wb-app-overlay
    [appIcon]="{
      type: AppIconSource.ICON,
      content: 'video',
      height: 32,
      width: 32
    }"
    [title]="state.title"
    [static]="true"
  ></app-wb-app-overlay>
</div>
<ng-template #videContainer>
  <div
    *ngIf="state.url; else uploadingIndicator"
    [style.height]="'100%'"
    [style.pointer-events]="(playModeEnabled$ | async) ? 'auto' : 'none'"
  >
    <div [hidden]="(displayVideoTooltip$ | async) === false" class="video-tooltip">
      <app-tooltip
        [text]="'Video playback is not synced with others.' | translate"
        [arrow]="'bottom'"
      ></app-tooltip>
    </div>
    <div
      *ngIf="videoIframe && (resettingVideo | async) === false"
      class="video-container"
      [innerHtml]="videoIframe"
    ></div>
    <img
      *ngIf="(playModeEnabled$ | async) === false && (videoThumbnail$ | async) !== undefined"
      class="thumbnail"
      [src]="videoThumbnail$ | async"
      [alt]="videoThumbnail$ | async"
    />
    <app-loading-v2
      *ngIf="videoIframe === undefined && (resettingVideo | async) === false"
      [fullParent]="true"
      [showMessage]="true"
      [message]="
        'Processing your video - it may take a few minutes before it is available to view.'
          | translate
      "
      [messageShowDelay]="0"
    ></app-loading-v2>
    <button
      class="play-btn"
      (click)="enablePlayMode()"
      *ngIf="videoIframe && (playModeEnabled$ | async) === false"
    >
      <svg-icon
        [style.pointer-events]="'all'"
        draggable="false"
        class="svg-icon"
        [icon]="'play_video'"
      ></svg-icon>
    </button>
  </div>
</ng-template>

<ng-template #uploadingIndicator>
  <app-resource-loading-item-canvas
    *ngIf="showUploadIndicator$ | async"
    [uploadId]="state.uid"
    [width]="state.width"
    [height]="state.height"
    [itemType]="ResourceItemModel.VIDEO"
  ></app-resource-loading-item-canvas>
</ng-template>
